import React from 'react';
import { FadeIn } from './FadeIn';
import { Brain, Smartphone, Moon, AlertTriangle, Clock } from 'lucide-react';
export function ScienceTruth() {
  const facts = [{
    icon: <Brain className="w-6 h-6 text-terracotta" data-id="element-292" />,
    brain: 'Cada notificación libera dopamina (el mismo químico que activan las drogas)',
    result: 'No puede parar aunque quiera'
  }, {
    icon: <Smartphone className="w-6 h-6 text-terracotta" data-id="element-293" />,
    brain: 'Las pantallas generan entre 400% y 600% más estimulación que el mundo real',
    result: 'El mundo real "aburre" después de la tablet'
  }, {
    icon: <Moon className="w-6 h-6 text-terracotta" data-id="element-294" />,
    brain: 'La luz azul bloquea la melatonina (hormona del sueño)',
    result: 'Duerme mal, se despierta irritable'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-terracotta" data-id="element-295" />,
    brain: 'El uso excesivo reduce el grosor de la corteza prefrontal',
    result: 'Menos control de impulsos, más berrinches'
  }, {
    icon: <Clock className="w-6 h-6 text-terracotta" data-id="element-296" />,
    brain: 'La OMS recomienda máximo 1 hora diaria para niños de 3-5 años',
    result: 'El promedio real es 4.5 horas diarias'
  }];
  return <section className="w-full py-24 px-6 bg-cream" data-id="element-297">
      <div className="max-w-5xl mx-auto" data-id="element-298">
        <FadeIn data-id="element-299">
          <div className="text-center mb-16" data-id="element-300">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-6" data-id="element-301">
              La Verdad Que Nadie Te Dice
            </h2>
            <p className="text-xl text-charcoal-light max-w-2xl mx-auto" data-id="element-302">
              Información breve pero necesaria sobre el daño real de las
              pantallas en el cerebro en desarrollo.
            </p>
          </div>
        </FadeIn>

        <div className="hidden md:block mb-16" data-id="element-303">
          <FadeIn delay={0.2} data-id="element-304">
            <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-cream-dark" data-id="element-305">
              <div className="grid grid-cols-2 bg-charcoal text-white p-6" data-id="element-306">
                <div className="font-bold text-lg flex items-center gap-2" data-id="element-307">
                  📱 Lo que pasa en el cerebro de tu hijo
                </div>
                <div className="font-bold text-lg flex items-center gap-2" data-id="element-308">
                  😰 El resultado en casa
                </div>
              </div>
              <div className="divide-y divide-cream-dark" data-id="element-309">
                {facts.map((fact, index) => <div key={index} className="grid grid-cols-2 p-6 hover:bg-cream/50 transition-colors" data-id="element-310">
                    <div className="flex items-start gap-4 pr-6" data-id="element-311">
                      <div className="mt-1 bg-cream p-2 rounded-full shrink-0" data-id="element-312">
                        {fact.icon}
                      </div>
                      <p className="text-charcoal-light leading-relaxed" data-id="element-313">
                        {fact.brain}
                      </p>
                    </div>
                    <div className="flex items-center pl-6 border-l border-cream-dark" data-id="element-314">
                      <p className="text-charcoal font-medium" data-id="element-315">{fact.result}</p>
                    </div>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Mobile View - Cards */}
        <div className="md:hidden space-y-6 mb-16" data-id="element-316">
          {facts.map((fact, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-317">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark relative overflow-hidden" data-id="element-318">
                <div className="absolute top-0 left-0 w-1 h-full bg-terracotta" data-id="element-319"></div>
                <div className="flex items-start gap-4 mb-4" data-id="element-320">
                  <div className="bg-cream p-3 rounded-full shrink-0" data-id="element-321">
                    {fact.icon}
                  </div>
                  <div data-id="element-322">
                    <span className="text-xs font-bold text-terracotta uppercase tracking-wider mb-1 block" data-id="element-323">
                      En el cerebro
                    </span>
                    <p className="text-charcoal-light text-sm" data-id="element-324">{fact.brain}</p>
                  </div>
                </div>
                <div className="bg-cream p-4 rounded-xl mt-4" data-id="element-325">
                  <span className="text-xs font-bold text-charcoal uppercase tracking-wider mb-1 block" data-id="element-326">
                    En casa
                  </span>
                  <p className="text-charcoal font-medium" data-id="element-327">{fact.result}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.3} data-id="element-328">
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-md border-l-8 border-amber relative" data-id="element-329">
            <div className="absolute -top-5 -left-5 bg-amber text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-xl shadow-lg" data-id="element-330">
              !
            </div>
            <p className="text-sm font-bold text-amber uppercase tracking-wider mb-4" data-id="element-331">
              Según estudios de la Academia Americana de Pediatría:
            </p>
            <blockquote className="text-xl md:text-2xl font-serif italic text-charcoal mb-0" data-id="element-332">
              "El exceso de pantallas en menores de 12 años está asociado a
              retrasos en el lenguaje, dificultades de atención, ansiedad
              infantil y problemas de sueño crónico."
            </blockquote>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-333">
          <p className="text-2xl md:text-3xl text-center font-serif text-charcoal mt-16 max-w-3xl mx-auto leading-relaxed" data-id="element-334">
            No se trata de ser el padre que prohíbe. Se trata de ser el padre
            que sabe{' '}
            <span className="text-terracotta font-bold" data-id="element-335">
              cómo guiar la transición
            </span>{' '}
            sin destruir la conexión.
          </p>
        </FadeIn>
      </div>
    </section>;
}